import { fetchWithTokenRefresh } from './fetchWrapper';
import { getOrCreateVisitorId } from './visitorId';
import { getOrCreateSessionId, touchSession, getDeviceMetadata } from './sessionManager';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

export interface TrackEventOptions {
  event_name: string;
  properties?: Record<string, string | number | boolean>;
  url_path?: string;
  page_title?: string;
  error_message?: string;
}

export async function sendAnalyticsEvent(options: TrackEventOptions): Promise<void> {
  if (import.meta.env.VITE_ANALYTICS_ENABLED === 'false') return;

  const visitorId = getOrCreateVisitorId();
  const sessionId = getOrCreateSessionId();
  const device = getDeviceMetadata();

  touchSession();

  const payload = {
    event_name: options.event_name,
    visitor_id: visitorId,
    session_id: sessionId,
    properties: options.properties ?? null,
    url_path: options.url_path ?? window.location.pathname,
    page_title: options.page_title ?? document.title,
    device_type: device.device_type,
    browser: device.browser,
    os: device.os,
    language: device.language,
    screen_size: device.screen_size,
    referrer_domain: document.referrer ? new URL(document.referrer).hostname : null,
    error_message: options.error_message ?? null,
  };

  try {
    await fetchWithTokenRefresh(`${API_URL}/analytics/events`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
  } catch {
    // Analytics should never break the app — silently fail
  }
}
